import {useOutletContext, useRouteLoaderData} from '@remix-run/react'
import type {HTMLAttributes} from 'react'
import type {Product, RootAndListContext, RootLoaderResponse} from '~/types'
import {cssDomains} from '~/utils/constants'
import {getDomainConfig} from '~/domains'
import {ProductSponsoredCard} from './sponsored-product-card'
import {SponsoredProductCardSpecsLayout} from './sponsored-product-card-specs-layout'
import {ProductSponsoredEUCard} from './sponsored-product-eu-card'

const specsCardDomains = ['expertstopchoice', 'expertstopchoices', 'bestexpertschoice']

const SponsoredProducts = ({...attributes}: HTMLAttributes<HTMLDivElement>) => {
  const {
    dataResponse: {sponsoredProducts, products},
  } = useOutletContext<RootAndListContext>()
  const {isUSLocale, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const [firstSponsoredProduct] = sponsoredProducts ?? []
  const {domainName, domainType} = getDomainConfig(domain, locale)

  const showSpecsCard = domainType === 'insider' || (isUSLocale && specsCardDomains.includes(domainName))

  const showEUcard = domainType === 'eu'
  const isMagaDomainType = domainType === 'maga'

  const showListingsCta =
    cssDomains.includes(domainName) &&
    products?.some(
      (product) => product?.storeListings && (product?.storeListings?.amazon || product?.storeListings?.ebay),
    )
  const renderCard = (index: number, product: Product) => {
    switch (true) {
      case isMagaDomainType || showEUcard:
        return <ProductSponsoredEUCard index={index} product={product} data-testid="sponsored-products" />
      case showSpecsCard:
        return <SponsoredProductCardSpecsLayout index={index} product={product} data-testid="sponsored-products" />
      default:
        return (
          <ProductSponsoredCard
            index={index}
            product={product}
            showListingsCta={showListingsCta}
            data-testid="sponsored-products"
          />
        )
    }
  }

  return firstSponsoredProduct && <div {...attributes}>{renderCard(0, firstSponsoredProduct)}</div>
}

export default SponsoredProducts
